<template>
  <div class="">

    <div class="trades-head" >
      <span @click="routeUser()" class="pointer hover">
        <Avatar  v-if="record._creator.avatar != null" class="trades-avatar" :src="`https://tradeinpool.com/upload/${record._creator.avatar}.png`" :size="40"></Avatar>
        <Avatar  v-else class="trades-avatar" :username="record._creator.username" :size="40"></Avatar>
        </span>
      <span class="trades-pl pointer" @click="goToDetail">
        <span
          class="pl-center"
          v-bind:class="record.ClosedProfitLoss > 0 ? 'up' : 'down'"
        >$ {{record.ClosedProfitLoss.toFixed(2)}}</span>
      </span>
      <span class="mr-2 pointer"><b @click="goToDetail">{{record._creator.username}}</b></span>

      <span class="pointer" @click="goToDetail">
      <v-tooltip v-if="record._prepare" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on"  size="18" color="#4dbac0" class="mr-1">hourglass_empty</v-icon>
              </template>
              <span>prepared trade</span>
            </v-tooltip>

            <v-tooltip v-if="record._entryLevel" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" color="#4dbac0" class="mr-1">calendar_view_day</v-icon>
              </template>
              <span>trade in zone</span>
            </v-tooltip>
      </span>
    </div>
    <div class="trades-content pointer" @click="goToDetail">
      {{record.OpenDateTime | timator(timezone)}}
      |
      {{record.Symbol.user}}
      |
      {{record.MaxOpenQuantity | sizator}}
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
var moment = require("moment-timezone");
export default {
  components:{
    Avatar
  },
  props: ["record"],
  data(){
    return{
    }
  },
  methods: {
    goToDetail() {
      return this.$router.push({ path: "/trades/" + this.record._creator.username +"/"+ this.record.openTimestamp});
    },
    routeUser() {
      return this.$router.push({path: "/user/"+this.record._creator.username});
    }
  },
  computed: {
    timezone() {
      return this.$store.getters.timezone;
    }
  },
  filters: {
    desimator: function(value) {
      var newTicker = value.replace("[Sim]", "");
      newTicker = newTicker.split("-");
      return newTicker[0];
    },
    timator: function(value, timezone) {
      var millis = value*1000
      var newTime = moment.tz(millis, timezone).format("HH:mm")
      return newTime;
    },
    sizator: function(value) {
      if (value > 1) return value + " pcs";
      else return value + " pc";
    }
  }
};
</script>

<style scoped>

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.loss {
  color: #e62163;
}

.profit {
  color: #79c04d;
}


.trades-head {
  width: 100%;
  position: relative;
  padding-right: 10px;
  padding-left: 55px;
  padding-top: 3px;
  height: 19px;
  float: left;
  color: #ffffff;
}

.trades-pl {
  float: right;
  font-size: 14px;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: bold;
}

.pl-center {
  position: relative;
  top: 7px;
}

.trades-content {
  width: 100%;
  float: left;
  margin-left: 55px;
  color: #808f9c;
}


</style>
